import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { useSelector, useDispatch } from 'react-redux';
import { addPresetRequest } from 'redux-api/action/preset';
import selectFilters from 'redux-api/reselect/filters';
import Modal from 'theme/modal';
import Text from 'theme/text';
import Input from 'theme/input';
import Button from 'theme/buttons/btn';
import ButtonBorder from 'theme/buttons/btn-border';
import Warning from 'theme/icons/warning';
import translations from 'translations';

const Wrapper = styled.div`
  width: 100%;

  & > .row {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }

  & > .wrap-error {
    display: flex;
    flex-direction: row;
    color: ${themeGet('colors.red_400')};
    min-height: 20px;
    margin-bottom: 4px;
  }
`;

function SavePreset({ isVisible, onClose, languageCode }) {
  const dispatch = useDispatch();

  const { isWaiting } = useSelector((state) => state.preset);
  const { compare, dataType, dateRange, dateTo, dateFrom, filters, terms, filtersData, termsData } =
    useSelector(selectFilters);

  const [title, setTitle] = useState('');
  const [error, setError] = useState(false);

  const handleChange = useCallback((e) => {
    setTitle(e.target.value);
    setError(false);
  }, []);

  const handleSave = useCallback(() => {
    setError(false);

    if (title.length > 0) {
      dispatch(
        addPresetRequest({
          preset: {
            compare,
            dataType,
            dateRange,
            dateTo,
            dateFrom,
            filters,
            terms,
            title,
            filtersData,
            termsData,
          },
          onError: () => {
            setError(true);
          },
          onSave: () => {
            onClose();
            setTitle('');
            setError(false);
          },
        }),
      );
    }
  }, [
    onClose,
    dispatch,
    compare,
    dataType,
    dateRange,
    dateTo,
    dateFrom,
    filters,
    terms,
    filtersData,
    termsData,
    title,
  ]);

  const handleCancel = useCallback(() => {
    setTitle('');
    onClose();
    setError(false);
  }, [onClose]);

  return (
    <Modal
      width="480px"
      isVisible={isVisible}
      onClose={onClose}
      title={translations[languageCode]['save preset']}
      bgColor="white"
    >
      <Wrapper>
        <Text color="grey_600" fontSize="display" lineHeight="display" fontWeight="medium" mb="xxs">
          {translations[languageCode].title}
        </Text>

        <Input
          style={{
            pb: 'xs',
          }}
          meta={{}}
          input={{
            onChange: handleChange,
            value: title,
          }}
          noError
        />

        <div className="wrap-error">
          {error ? (
            <>
              <Warning />
              <Text
                fontSize="display"
                lineHeight="display"
                fontWeight="medium"
                ml="xxs"
                color="red_400"
              >
                {translations[languageCode]['duplicate error']}
              </Text>
            </>
          ) : null}
        </div>

        <div className="row">
          <ButtonBorder
            onClick={handleCancel}
            style={{
              width: '100%',
              maxWidth: '110px',
              minWidth: '110px',
              height: '48px',
              mr: 's',
              p: 0,
            }}
            type="button"
            label={translations[languageCode].cancel}
          />

          <Button
            onClick={handleSave}
            style={{
              width: '100%',
              maxWidth: '110px',
              minWidth: '110px',
              height: '48px',
              p: 0,
            }}
            isWaiting={isWaiting}
            type="button"
            label={translations[languageCode].save}
          />
        </div>
      </Wrapper>
    </Modal>
  );
}

export default SavePreset;
